/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import { StyleSheet, View } from 'react-native';
import Shimmer from '~global/Shimmer';
import { isWeb } from '~global/screens';

const SearchProductPlaceHolder = (props) => {
  return (
    <View style={styles.listProductPlaceHolder}>
      <View style={{ marginBottom: 12 }}>
        <Shimmer width="100%" height={75} />
      </View>

      <View style={{ marginBottom: 12 }}>
        <Shimmer width="100%" height={75} />
      </View>

      <View style={{ marginBottom: 12 }}>
        <Shimmer width="100%" height={75} />
      </View>

      {!isWeb && (
        <>
          <View style={{ marginBottom: 12 }}>
            <Shimmer width="100%" height={75} />
          </View>

          <View style={{ marginBottom: 12 }}>
            <Shimmer width="100%" height={75} />
          </View>

          <View style={{ marginBottom: 12 }}>
            <Shimmer width="100%" height={75} />
          </View>
        </>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  listProductPlaceHolder: {
    marginBottom: 24,
    paddingHorizontal: 16,
    ...(isWeb && {
      marginTop: 10,
    }),
  },
});

export default SearchProductPlaceHolder;
